<app-breadcrumbs title="CALENDAR" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
    <div class="col-12">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-h-100">
                    <div class="card-header border-0 ">
                        <div class="d-grid d-md-flex align-items-center">
                            <h5 class=" flex-grow-1 fs-17 " style="padding-top: 0.5%;"
                                i18n="@@RequisitionList_Text_RequisitionList">
                                Calendar</h5>

                            <div class="d-grid d-sm-flex align-items-center gap-2">
                                <div class=" d-flex justify-content-end gap-2">
                                    <button class="btn btn-success add-btn" (click)="newEvent()">
                                        <i class="ri-add-fill me-1 align-bottom"></i>
                                        <span i18n="@@"> Add Event </span>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="card-header card-body bg-soft-light border border-dashed border-start-0 border-end-0">
                        <div class="d-md-flex align-items-center gap-2 searchBarsOverflow">
                            <div class="col-12 col-md-4 ">
                                <div class="d-flex align-items-center gap-2 ">
                                    <div class="search-box flex-grow-1">
                                        <input type="text" name="searchTerm"
                                            class="form-control search bg-light border-light"
                                            placeholder="Search by event name"
                                            [(ngModel)]="calendarListService.searchTerm">
                                        <i class="ri-search-line search-icon"></i>
                                        <i class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                                            *ngIf="calendarListService.searchTerm && calendarListService.searchTerm.length >0"
                                            style="font-size: 1rem;
                                        position: absolute;
                                        cursor: pointer;
                                        right: 13px;
                                        top: 0;
                                        height: 100%;
                                        display: flex;
                                        align-items: center;
                                        color: #878a99;" (click)="clearSearch(calendarListService)"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 ">
                                <app-attendees-selection [selectedModelsArray]="selectedModelsArray" [searchMode]="true"
                                    class="d-block" [maxItems]="1" [searchPlaceHolderText]="'Search attendees'"
                                    (updateAttendees)="attendeeSearch($event)"></app-attendees-selection>
                            </div>
                            <div class="col-12 col-md-4 ">
                                <div class="d-flex align-items-center gap-2 bg-light border-light form-control">
                                    <input type="text" class="form-control bg-light border-0 p-0"
                                        placeholder="Select date/range" [(ngModel)]="eventDateRange"
                                        (flatpickrClose)="triggerDateSearch($event)" mwlFlatpickr [disableMobile]="true"
                                        [convertModelValue]="true" mode="range" altFormat="d M, Y" dateFormat="d M, Y">
                                    <i *ngIf="calendarListService.to"
                                        class="mdi mdi-close-circle search-widget-icon search-widget-icon-close cursor-pointer  d-flex align-items-center"
                                        style="
                                        line-height: 0; font-size: 1rem; color: #878a99;" (click)="clearDate()"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">

                        <full-calendar id="calendarDisplay" #calendar [options]="calendarOptions" style="max-height: 70vh !important;"></full-calendar>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>